import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, of, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(private _httpClient: HttpClient) {}

    // Setter & getter for user
    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Get the current logged in user data (dari localStorage)
     */
    get(): Observable<User> {
        const userStr = localStorage.getItem('user');

        // Note: The previous code seemed to expect raw JSON in 'user'.
        // However, RoleGuard in previous steps used decryption.
        // I will assume for now we might be storing it simply or the user wants it simple.
        // If ApiService stores it encrypted, this might fail to parse if not handled.
        // But for "kosongan" project, let's just use a default fallback if parsing fails or empty.
        
        try {
            if (userStr) {
                // Try parsing direct JSON first
                let user: User = JSON.parse(userStr);
                this._user.next(user);
                return of(user);
            }
        } catch (e) {
            console.warn('Failed to parse user from localStorage', e);
        }

        // Default fallback user for development/start
        const defaultUser: User = {
            id: 'admin-id',
            name: 'Admin User',
            username: 'admin',
            email: 'admin@example.com',
            avatar: 'assets/images/avatars/male-01.jpg',
            status: 'online'
        };
        
        this._user.next(defaultUser);
        return of(defaultUser);
       
        /* 
        // fallback kalau kosong → hit API (Disabled for base project)
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
                localStorage.setItem('user', JSON.stringify(user));
            })
        );
        */
    }

    /**
     * Update the user
     */
    update(user: User): Observable<any> {
        // Mock update
        this._user.next(user);
        return of(user);
        
        /*
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
                localStorage.setItem('user', JSON.stringify(response));
            })
        );
        */
    }
}
